//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    items: {
      default: function () {
        return []
      },
      type: Array
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectedItemsIds: {
      default: function () {
        return []
      },
      type: Array
    },
    filteredItems: {
      default: function () {
        return []
      },
      type: Array
    },
    columnNames: {
      default: function () {
        return []
      },
      type: Array
    },
    primaryKey: {
      default: 'id',
      type: String
    },
    disableFilter: {
      default: false,
      type: Boolean
    },
    disablePagination: {
      default: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      pagination: this.disablePagination ? {
        page: 1,
        rowsPerPage: 0
      } : {
        page: 1,
        rowsPerPage: 50
      },

      displayedTableItems: [],
      filteredItemsIdsLocal: null,

      sortColumn: null,
      debounceTriggerSort: function () {}
    }
  },
  watch: {
    items: function (result) {
      if (result) {
        this.displayedTableItems = result
      }
    },
    filteredItems: function (result) {
      this.filteredItemsIdsLocal = result
    }
  },
  created: function () {
    this.selectedItemsIdsLocal = this.selectedItemsIds
    this.displayedTableItems = this.items
  },
  methods: {
    onSelectItem: function (item) {
      this.$emit('selected-item', item)
      const selectedItemsIdsLocal = this.selectedItemsIds
      if (item.isChecked && !selectedItemsIdsLocal.includes(item[this.primaryKey])) {
        selectedItemsIdsLocal.push(item[this.primaryKey])
      } else if (!item.isChecked && selectedItemsIdsLocal.includes(item[this.primaryKey])) {
        selectedItemsIdsLocal.splice(selectedItemsIdsLocal.indexOf(item[this.primaryKey]), 1)
      }
      this.$emit('selected-items-ids', selectedItemsIdsLocal)
    },
    onSelectAllItems: function (isChecked) {
      if (isChecked) {
        const key = this.primaryKey
        const filterData = this.items.filter((item) => !item._disabled).map((item) => item[key])
        this.$emit('selected-items-ids', filterData)
      } else {
        this.$emit('selected-items-ids', [])
      }
    },
    getRowStyle: function (data) {
      // Для таблицы актуализации
      let classes = ''
      if (data.type === 'actual' || data.type === 'actualityTimeExceedsPR4' || data.type === 'actualityTimeExceedsPR1') {
        if (data.type === 'actualityTimeExceedsPR4' || data.type === 'actualityTimeExceedsPR1') {
          classes = classes + 'actualized-another-report-row '
        }
        if (!data.value || data.value === 'null, null') {
          classes = classes + 'not-actualized-row '
        }
        if (data.value !== undefined && data.value !== data.dictValue) {
          classes = classes + 'actualized-row '
        }
        return classes
      }

      // Для таблицы НШС
      if (data.sv == 'info') {
        return 'normal-message'
      } else if (data.sv == 'warning') {
        return 'warning-message'
      } else if (data.sv == 'critical') {
        return 'critical-message'
      }

      // Для таблиц списаний
      if (data.noted !== undefined && data.toolName && data.amount) {
        if (data.noted == 'hasNotes') {
          return 'has-notes'
        } else if (data.noted == 'noNotes') {
          return 'no-notes'
        }
      }
    }
  }
}

